import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const AnalyticsView = () => import('./AnalyticsView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/analytics'),
      component: SettingsContent,
      props: {
        headerTitle: 'ANALYTICS',
        icon: 'arrow-trending-lines',
        keepAlive: false,
      },
      children: [
        {
          path: '',
          name: 'analytics',
          roles: ['administrator', 'agent'],
          component: AnalyticsView,
        },
      ],
    },
  ],
};
